import { RoomeTimeOption } from './codingRooms.types'

export const allTopics = [
  {
    key: 'arrays',
    label: 'Arrays'
  },
  {
    key: 'strings',
    label: 'Strings'
  },
  {
    key: 'hashmap',
    label: 'Hashmap'
  },
  {
    key: 'tree',
    label: 'Tree'
  },
  {
    key: 'matrix',
    label: 'Matrix'
  },
  {
    key: 'graph',
    label: 'Graph'
  },
  {
    key: 'linkedlist',
    label: 'Linked list'
  },
  {
    key: 'stacks',
    label: 'Stacks'
  },
  {
    key: 'binarysearch',
    label: 'Binary Search'
  },
  {
    key: 'queue',
    label: 'Queues'
  },
  {
    key: 'heaps',
    label: 'Heaps'
  },
  {
    key: 'dynamicprogramming',
    label: 'Dynamic Programming'
  },
  {
    key: 'backtracking',
    label: 'Back Tracking'
  },
  {
    key: 'maths',
    label: 'Math'
  },
  {
    key: 'greedy',
    label: 'Greedy'
  }
] as const

export const roomTimeOptions: RoomeTimeOption[] = [
  { key: '0', label: '15' },
  { key: '1', label: '30' },
  { key: '2', label: '60' }
]

export const allDifficulties = ['easy', 'medium', 'hard'] as const

export const wordList = [
  'Agile',
  'Array',
  'Binary',
  'Branch',
  'Byte',
  'Case',
  'Class',
  'Code',
  'Data',
  'Debug',
  'Design',
  'Element',
  'Graph',
  'Heap',
  'IDE',
  'Link',
  'List',
  'Loop',
  'Method',
  'Module',
  'Object',
  'Queue',
  'Scope',
  'Stack',
  'String',
  'Struct',
  'System',
  'Thread',
  'Time',
  'Tree',
  'Type',
  'Vector',
  'Virtual',
  'Void',
  'Thread',
  'Time',
  'Trace',
  'Tree',
  'Tuple',
  'Type',
  'Vector',
  'Virtual',
  'Link',
  'List',
  'Loop',
  'Method',
  'Module',
  'Object',
  'Define',
  'Design',
  'Develop',
  'Divide',
  'Dynamic',
  'Compute'
] as const
